<template>
  <div>
    <div v-if="info.msgWithdrawStatus===0">
      <!--普通文本-->
      <div v-if="info.csdrType===31">
        <p class="talkMsg" :style="{webkitLineClamp:info.lineLimit}">{{ info.csdrContent }}</p>
        <span class="watchDetail" v-if="info.csdrContent.length>105&&info.lineLimit!=='inherit'"
              @click="watchDetail">查看</span>
      </div>
      <!--富文本-->
      <p v-if="info.csdrType===32" v-html="info.csdrContent" class="richText"></p>
      <!-- Markdown -->
      <div v-if="info.csdrType===35">
        <StreamMDRender :content="info.csdrContent" @question-click="forwardQuestionClick"/>
      </div>
      <!--图片-->
      <img v-if='info.csdrType===42' :src="$originApi+info.csdrAtt" @click="showImg($originApi+info.csdrAtt)"
           class="imgMsg">
      <!--附件-->
      <attachment v-if="info.csdrType===41" :fileInfo="info"></attachment>
      <!--语音消息-->
      <div v-if="info.csdrType===33" class="voice-container" @click="playVoice(info)">
        <div class="voice-message" :class="{ 'playing': isPlaying }">
          <span class="play-symbol"></span>
        </div>
        <span class="voice-length">{{ info.voiceDuration  + '"' }}</span>
      </div>
    </div>
    <p v-if="info.msgWithdrawStatus===1">{{ info.msgWithdrawHint }}</p>
  </div>
</template>

<script>
import attachment from '@/components/chat/attachment'
import {ImagePreview, Toast} from 'vant'
import {getLoginInfo} from '../../util/auth'
import StreamMDRender from '@/components/chat/StreamMDRender'

export default {
  name: 'msgType',
  props: ['info'],
  components: {attachment, StreamMDRender},
  data () {
    return {
      loginInfo: getLoginInfo(),
      isPlaying: false,
      audioElement: null
    }
  },
  methods: {
    forwardQuestionClick (question) {
      this.$emit('question-click', question)
    },
    showImg (img) {
      ImagePreview([img])
    },
    openEvaluate () {
      this.showEvaluate = true
    },
    watchDetail () {
      this.info.lineLimit = 'inherit'
    },
    playVoice (item) {
      if (this.isPlaying) {
        this.stopVoice()
        return
      }

      let audioUrl = ''

      if (item.audioUrl) {
        audioUrl = item.audioUrl
      } else if (item.csdaBase) {
        audioUrl = `data:audio/wav;base64,${item.csdaBase}`
      } else {
        Toast.fail('语音数据不存在')
        return
      }

      this.audioElement = new Audio(audioUrl)

      this.audioElement.play().then(() => {
        this.isPlaying = true
      }).catch(err => {
        console.error('播放语音失败:', err)
        Toast.fail('播放语音失败')
        this.stopVoice()
      })

      this.audioElement.onended = () => {
        this.stopVoice()
      }

      this.audioElement.onerror = () => {
        console.error('语音播放错误')
        Toast.fail('播放语音失败')
        this.stopVoice()
      }
    },
    stopVoice () {
      if (this.audioElement) {
        this.audioElement.pause()
        this.audioElement = null
      }
      this.isPlaying = false
    }
  },
  beforeDestroy () {
    this.stopVoice()
  }
}
</script>

<style scoped>
.imgMsg {
  width: 150px;
}

.watchDetail {
  color: #448af7;
  font-size: 14px;
}

.call {
  color: #1e90ff;
}

.evaluateButton {
  color: #1e90ff;
}

.evaluate {
  width: 22px;
  vertical-align: middle;
}

.richText {
  white-space: pre-wrap;
}

/deep/ .richText ol {
  padding-left: 15px;
  list-style: decimal !important;
}

/deep/ .richText ul {
  padding-left: 15px;
  list-style-type: disc !important;
}

/deep/ .richText img {
  max-width: 100% !important;
}

/* 语音消息样式 */
.voice-container {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  min-width: 80px;
  height: 14px;
}

.voice-message {
  position: relative;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.voice-message.playing {
  animation: pulse 1.5s infinite;
}

.voice-message.playing .play-symbol {
  display: none;
}

.voice-message.playing::before {
  content: '';
  position: absolute;
  width: 8px;
  height: 8px;
  border: 2px solid #333;
  border-radius: 50%;
  animation: sound-wave 1s infinite ease-out 0.2s;
}

.voice-message.playing::after {
  content: '';
  position: absolute;
  width: 12px;
  height: 12px;
  border: 2px solid #333;
  border-radius: 50%;
  animation: sound-wave 1s infinite ease-out;
}

.play-symbol {
  width: 0;
  height: 0;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-left: 10px solid #333;
  margin-left: 2px;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.8;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes sound-wave {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(2);
    opacity: 0;
  }
}

.voice-length {
  font-size: 14px;
  color: #333;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/chat/msgType.vue